import rest from 'rest';
import mime from 'rest/interceptor/mime';
import errorCode from 'rest/interceptor/errorCode';
import pathPrefix from 'rest/interceptor/pathPrefix';
import params from 'rest/interceptor/params';
import jsonContentTypeHeaders from './interceptors/JsonContentTypeHeader';

export default rest
  .wrap(pathPrefix, { prefix: S3_SIGNED_URL_HOST })
  .wrap(params)
  .wrap(jsonContentTypeHeaders)
  .wrap(mime)
  .wrap(errorCode);
